export enum IdentityVerificationStatus {
  NONE = 'NONE',
  PROCESSING = 'PROCESSING',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REFUSED = 'REFUSED',
}
